import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { NPwa } from '../pwa.interface';
import { PwaUpdateService } from './pwa-update.service';

@Component({
    selector: 'pwa-update',
    templateUrl: './pwa-update.component.html',
    styleUrls: ['./pwa-update.component.scss'],
    standalone: true,
    imports: [TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PwaUpdateComponent {
    @HostBinding('class._is-ios')
    get isIos(): boolean {
        return this.pwaUpdateService.modalPlatform === NPwa.EPlatform.IOS;
    }

    constructor(protected pwaUpdateService: PwaUpdateService) {}

    reload(): void {
        this.pwaUpdateService.reload();
    }

    modalClose(): void {
        this.pwaUpdateService.modalClose();
    }
}
